// extracted by mini-css-extract-plugin
export default {"section":"Faqs_section__sUQwE","intro":"Faqs_intro__MNTMs","eyebrow":"Faqs_eyebrow__LpJQF","faqGrid":"Faqs_faqGrid__JuSgO","column":"Faqs_column__Pd2Me"};